import { render, staticRenderFns } from "./QuotationCostsCardCafezal.vue?vue&type=template&id=0f918095"
import script from "./QuotationCostsCardCafezal.vue?vue&type=script&lang=js"
export * from "./QuotationCostsCardCafezal.vue?vue&type=script&lang=js"
import style0 from "./QuotationCostsCardCafezal.vue?vue&type=style&index=0&id=0f918095&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports